<template>
  <div class="content">
    <div class="loginBg">
      <div class="loginDiv">
        <img alt="" :src="homeImg">
      </div>
      <div class="loginText">
        <p>上传自定义登录背景</p>
        <p>尺寸大小：1920X600像素（图片大小1M以内）</p>
        <p>仅支持JPG、 PNG图片文件</p>
        <p>此设置仅针对自定义网站域名生效，请在下方设置</p>
        <el-upload
          class="upload-demo"
          :action="url"
          accept = ".jpg,.png"
          :on-success="handleAvatarSuccess"
          :show-file-list="false"
          list-type="picture">
          <el-button size="small" type="primary">上传图片</el-button>
        </el-upload>
      </div>
    </div>
    <div class="paltform">
      <div>
        <p>配置管理平台简称（如：桔子智联）</p>
        <el-input v-model="queryParams.name" placeholder="桔子智联"></el-input>
      </div>
      <div>
        <p>配置管理平台URL域名（如：iot.xxx.com）</p>
        <el-input v-model="queryParams.platformDomain" placeholder="iot.juzi1688.cn"></el-input>
      </div>
      <div>
        <p>配置API接口URL域名（如：iot.xxx.com）</p>
        <el-input v-model="queryParams.apiDomain" placeholder="iot.juzi1688.cn"></el-input>
      </div>
      <div>
        <p>配置H5平台URL域名（如：iot.xxx.com）</p>
        <el-input v-model="queryParams.h5Domain" placeholder="iot.juzi1688.cn"></el-input>
        <span>配置后，请前往【公众号模板配置】中配置H5选项，从而保证H5地址显示为您自己的服务器。</span>
      </div>
      <div>
        <p>选择公众号</p>
        <el-select v-model="queryParams.appId"    placeholder="请选择公众号" style="width: 85%">
            <el-option v-for="item in apps" :key="item.appId" :label="item.name" :value="item.appId" ></el-option>
        </el-select>
      </div>
    </div>
    <div class="saveBtn">
      <el-button size="small" type="primary" @click="submitBut">提交数据</el-button>
    </div>
  </div>
</template>
<script>
import { saveUpdatePlatform } from "@/api/api.js";
import { platformDetail } from "@/api/api.js";
import { wxConfig } from "@/api/api.js";
export default {
  name:'platformForm',
  data() {
    return{
      id:'',
      homeImg:"",
      url:"cms/file/upload/loginBg",
      apps:[],
      queryParams:{
        name : "",
        h5Domain : "",
        apiDomain : "",
        platformDomain : "",
        appId : ""
      }
    }
  },
  methods: {
    handleAvatarSuccess(res){
      if(res.code == 200){
          this.homeImg = "/cms/" + res.data.url;
      }
    },
    initData(){
      if(!!this.id){
        let params = {
            id : this.id
        };
        platformDetail(params).then(res =>{
          if(res.data.code == 200){
            this.queryParams = res.data.data;
            let loginImgUrl  = res.data.data.loginImgUrl;
            if(!!loginImgUrl){
              this.homeImg = res.data.data.loginImgUrl;
            }else{
              this.homeImg = require("../../assets/img/bj3.jpg");
            }
            
          }
        });
      }
    },
    getApp(){
      let params = {
        type: "2",
        userId:"xt"
      }
      wxConfig(params).then(res=>{
          if(res.data.code == 200){
            this.apps = res.data.data;
          }
      });
    },
    submitBut(){
      let params ={
        ...this.queryParams,
        id : this.id
      }
      params.loginImgUrl = this.homeImg
      saveUpdatePlatform(params).then(res =>{
        if(res.data.code == 200){
          this.$notify({
            title: '成功',
            message: '信息提交成功',
            type: 'success'
          });
          this.$router.push({ path: '/platformSetting/platformIndex'});
        }
      })
    }
  },
  created() {
    this.id = this.$route.params && this.$route.params.id;
    this.initData();
    this.getApp();
  },
  mounted() {
    
  },
};
</script>

<style scoped lang="less">
.loginBg{
  width: 100%;
  display: flex;
  .loginDiv{
    width: 300px;
    height: 170px;
    line-height: 170px;
    text-align: center;
    border: 1px solid #ddd;
    img{
      padding: 8px;
      width: 100%;
      height: 100%;
    }
  }
  .loginText{
    margin-left: 20px;
    p{
      color: #606266;
      font-size: 15px;
      padding: 2px 0;
    }
    .upload-demo{
      margin-top: 18px;
    }
  }
  .paltform{
    margin-left: 20px;
    .el-input{
      width: 300px;
      display: block;
      margin: 2px;
    }
  }
}
.textWd{
  margin-top: 20px;
  p{
    color: #606266;
    padding: 5px 0;
    font-size: 15px;
  }
  .paltformTable {
    width: 840px;
    background: #fff;
    font-size: 12px;
    margin-top: 5px;
    th{
      padding: 0 10px;
      border-bottom: 1px solid #ddd;
      height: 30px;
      line-height: 30px;
      font-weight: normal;
      color: #9a959c!important;
      text-align: left;
    }
    td{
      padding: 6px 10px;
      font-size: 14px;
      color: #2a2a2a;
      border-bottom: 1px solid #ddd;
    }
  }
}
.paltform{
  margin: 20px 0 80px 0;
  color: #606266;
  font-size: 14px;
  div{
    padding:10px 0;
    .el-input{
      width: 300px;
    }
    span{
      margin-left: 10px;
    }
  }
}
.saveBtn{
  background: #F8F8F8;
  padding: 15px 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  margin-left: -50px;
  button{
    border-radius: 5px;
    font-size: 14px;
    width: 120px;
    height: 40px;
  }
}
</style>


